/*
  Custom element for sections/custom-reviews.liquid. Handles both the
  manual prev/next buttons (name="previous"/"next", same convention as
  Dawn's own <slider-component>) and auto-scroll — advancing by exactly
  one card, looping back to the start once it reaches the end (and to
  the end once it reaches the start, going backwards). Not built on
  Dawn's own SliderComponent (assets/global.js) since that class assumes
  a non-looping, page-counted slider — a fresh, self-contained
  implementation was simpler than reworking its assumptions.

  Auto-scroll interval comes from data-autoplay-seconds (0 disables it,
  see section.settings.id_autoplay_seconds). Pauses on hover/focus so it
  doesn't fight a visitor who's actively reading or interacting.

  Nav buttons render twice in the markup (a desktop set inline with the
  header, a mobile set below the track, toggled with CSS) — every
  matching button gets the same click handler attached, regardless of
  which set is currently visible.
*/
class ReviewsCarousel extends HTMLElement {
  constructor() {
    super();
    this.track = this.querySelector('[id^="Slider-"]');
    this.slides = Array.from(this.querySelectorAll('[id^="Slide-"]'));
    this.prevButtons = Array.from(this.querySelectorAll('button[name="previous"]'));
    this.nextButtons = Array.from(this.querySelectorAll('button[name="next"]'));

    if (!this.track || this.slides.length < 2) return;

    this.itemOffset = this.slides[1].offsetLeft - this.slides[0].offsetLeft;

    this.prevButtons.forEach((button) => button.addEventListener('click', () => this.step(-1)));
    this.nextButtons.forEach((button) => button.addEventListener('click', () => this.step(1)));

    const seconds = parseFloat(this.dataset.autoplaySeconds);
    if (seconds > 0) {
      this.autoplayDelay = seconds * 1000;
      this.play();
      this.addEventListener('mouseenter', this.pause.bind(this));
      this.addEventListener('mouseleave', this.play.bind(this));
      this.addEventListener('focusin', this.pause.bind(this));
      this.addEventListener('focusout', this.play.bind(this));
    }
  }

  step(direction) {
    const maxScroll = this.track.scrollWidth - this.track.clientWidth;
    let target = this.track.scrollLeft + direction * this.itemOffset;

    if (target > maxScroll - 2) {
      target = 0;
    } else if (target < 0) {
      target = maxScroll;
    }

    this.track.scrollTo({ left: target, behavior: 'smooth' });
  }

  play() {
    this.pause();
    this.timer = setInterval(() => this.step(1), this.autoplayDelay);
  }

  pause() {
    clearInterval(this.timer);
  }
}

customElements.define('reviews-carousel', ReviewsCarousel);